import React, { useEffect,  useState } from "react";

import GreyTable from "../../../../components/Tables/GreyTable";
import { Col, Row, Container, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { resetQualityWise, QualityWise1, resetDelhivery, Delhivery1 } from "../../../../Redux/Slice/Grey/GreyDashboard/GreyDashboardSlice";
import { Loader } from "../../../../components/Loader/Loader";
import { useTheme } from "../../../../Themecontext/Themecontext";


export default function QualityWise({ selectedProduction, selectedAccount }) {


  const dispatch = useDispatch();

  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { Delhiverydata } = useSelector((state) => state.GreyDashboardSlice);


  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );

  const { theme } = useTheme();
  const isdark = theme;



  useEffect(() => {
    dispatch(resetDelhivery())
    dispatch(Delhivery1({
      groupIDs: selectedProduction.join(","),
      partyIDs: selectedAccount.join(",")
    }))
  }, [selectedProduction, selectedAccount])


  const formatFinancialYearFromRange = (range) => {
    if (!range) return "";

    // split "1/04/2024 - 31/03/2025"
    const parts = range.split("-");

    if (parts.length === 2) {
      const startPart = parts[0].trim(); // "1/04/2024"
      const endPart = parts[1].trim();   // "31/03/2025"

      const startYear = startPart.split("/").pop(); // 2024
      const endYear = endPart.split("/").pop().slice(-2); // 25

      return `${startYear}-${endYear}`;
    }

    return "";
  };

  const yearLabel = formatFinancialYearFromRange(
    Delhiverydata?.Quality?.[0]?.FAcYear
  );

  const tableData = (Delhiverydata?.Quality || []).map(
    (row, index, arr) => ({
      // srNumber: (index + 1),
      ItemName: row.ItemName,
      FinishMeter: row.FinishMeter,
    })
  );

  const columns = [
    {
      label: "Sr No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
    },
    {
      label: "Quality Name",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
    },
    {
      label: `Meter (${yearLabel})`,
      key: "FinishMeter",
      align: "right",
      format: true,
      colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
  ];


  const tableData1 = (Delhiverydata?.Quality || []).map((item, index) => ({
    // srNumber: index + 1,
    ItemName: item.ItemName,

    FinApril: item.FinApril,
    FinMay: item.FinMay,
    FinJun: item.FinJun,
    FinJuly: item.FinJuly,
    FinAugust: item.FinAugust,
    FinSeptember: item.FinSeptember,
    FinOctober: item.FinOctober,
    FinNovember: item.FinNovember,
    FinDecember: item.FinDecember,
    FinJanuary: item.FinJanuary,
    FinFebruary: item.FinFebruary,
    FinMarch: item.FinMarch,
    FinishMeter: item.FinishMeter,
  }));
  const columns1 = [
    { label: "Charts", key: "charts" },
    {
      label: "Sr No.",
      key: "srNumber",
      align: "center",
      colors:
        isdark === "light"
          ? iscolour?.Colour2
          : iscolourDark?.Colour2,
    },
    {
      label: "Quality Name",
      key: "ItemName",
      align: "left",
      colors:
        isdark === "light"
          ? iscolour?.Colour2
          : iscolourDark?.Colour2,
    },

    {
      label: "Total Meter",
      key: "FinishMeter",
      align: "right",
      format: true,
      colors:
        isdark === "light"
          ? iscolour?.Colour1
          : iscolourDark?.Colour5,
    },
    {
      label: "Apr", key: "FinApril", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
    },
    { label: "May", key: "FinMay", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { label: "Jun", key: "FinJun", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { label: "Jul", key: "FinJuly", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { label: "Aug", key: "FinAugust", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { label: "Sep", key: "FinSeptember", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { label: "Oct", key: "FinOctober", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { label: "Nov", key: "FinNovember", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { label: "Dec", key: "FinDecember", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { label: "Jan", key: "FinJanuary", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { label: "Feb", key: "FinFebruary", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { label: "Mar", key: "FinMarch", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
  ];

  const isNoData =
    !Delhiverydata?.Master || Delhiverydata.Master.length === 0

  if (Delhiverydata === null) {
    return (
      <div className=" flex justify-center items-center h-screen text-xl " >
        <Loader />
      </div>
    );
  }



  return (
    <Container fluid style={{ padding: 0, margin: 0 }}>
      <Row className="justify-content-center" style={{ margin: 0, padding: 0 }}>

        <Col md={12} style={{ padding: 0, margin: 0 }}>
          <div
            style={{
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              overflow: "hidden",
              margin: 0,
              boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
            }}
          >
            <div
              style={{
                backgroundColor:
                  isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                padding: "14px",
                margin: 0,
              }}
            >
              <h2
                style={{

                  fontSize: "18px",
                  margin: 0,
                  letterSpacing: "1px",
                  fontWeight: "700"
                }}
              >

                QUALITYWISE DATA

              </h2>
              <p
                className="text-sm mt-1 mb-0"

              >
                Financial Year: {yearLabel}
              </p>
            </div>

            <div
              style={{
                backgroundColor: "rgb(255, 255, 255)",
                // padding: "20px",
                margin: 0,
              }}
            >
              <GreyTable columns={columns} data={tableData} iscolourDark={iscolourDark}
                iscolour={iscolour} />
            </div>
          </div>
        </Col>
        <Col md={12} className="pt-4" style={{ padding: 0, margin: 0 }}>
          <div
            style={{
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
              overflow: "hidden",
              margin: 0,
              boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
            }}
          >
            <div
              style={{
                backgroundColor:
                  isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
                padding: "14px",
                margin: 0,
              }}
            >
              <h2
                style={{
                  fontSize: "18px",
                  margin: 0,
                  letterSpacing: "1px",
                  fontWeight: "700"
                }}
              >
                MONTHWISE DATA
              </h2>
              <p
                className="text-sm mt-1 mb-0"
              >
                Financial Year: {yearLabel}
              </p>
            </div>

            <div
              style={{
                backgroundColor: "rgb(255, 255, 255)",
                // padding: "20px",
                margin: 0,
              }}
            >
              <GreyTable columns={columns1} data={tableData1} iscolourDark={iscolourDark}
                iscolour={iscolour} />
            </div>
          </div>
        </Col>

      </Row>
    </Container>
  );
}